'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FORWARD_PAGE = exports.FORWARD_PAGE = 'FORWARD_PAGE';
var BACK_PAGE = exports.BACK_PAGE = 'BACK_PAGE';
var SET_NUM_PAGES = exports.SET_NUM_PAGES = 'SET_NUM_PAGES';

var FORM_ERROR = exports.FORM_ERROR = 'FORM_ERROR';

var RESET_QUOTE = exports.RESET_QUOTE = 'RESET_QUOTE';

/**
 * Async actions
 *
 * For actions relating to HTTP requests, follow the convention <METHOD>_<DESC>
 *   and <METHOD>_<DESC>_INIT to indicate the initiation of a request.
 * Note that the actions dispatched for success/error use the same constant, e.g.
 *   POST_AUTH_COMPLETE is used as the action type for a successful request for
 *   an auth token as well as for a failed request. The action's payload and error
 *   fields will indicate whether it is a success or error.
 */

var GET_FORM_CONFIG_INIT = exports.GET_FORM_CONFIG_INIT = 'GET_FORM_CONFIG_INIT';
var GET_FORM_CONFIG_COMPLETE = exports.GET_FORM_CONFIG_COMPLETE = 'GET_FORM_CONFIG_COMPLETE';
var GET_SAVED_QUOTE_INIT = exports.GET_SAVED_QUOTE_INIT = 'GET_SAVED_QUOTE_INIT';
var GET_SAVED_QUOTE_COMPLETE = exports.GET_SAVED_QUOTE_COMPLETE = 'GET_SAVED_QUOTE_COMPLETE';
var GET_RENEWAL_COMPLETE = exports.GET_RENEWAL_COMPLETE = 'GET_RENEWAL_COMPLETE';
var GET_APP_QUOTE_INIT = exports.GET_APP_QUOTE_INIT = 'GET_APP_QUOTE_INIT';
var GET_APP_QUOTE_COMPLETE = exports.GET_APP_QUOTE_COMPLETE = 'GET_APP_QUOTE_COMPLETE';
var GET_CONFIRMATION_TEXT_INIT = exports.GET_CONFIRMATION_TEXT_INIT = 'GET_CONFIRMATION_TEXT_INIT';
var GET_CONFIRMATION_TEXT_COMPLETE = exports.GET_CONFIRMATION_TEXT_COMPLETE = 'GET_CONFIRMATION_TEXT_COMPLETE';
var GET_APPLICATION_DATA_INIT = exports.GET_APPLICATION_DATA_INIT = 'GET_APP_DATA_INIT';
var GET_APPLICATION_DATA_COMPLETE = exports.GET_APPLICATION_DATA_COMPLETE = 'GET_APP_DATA_COMPLETE';
var POST_AUTH_INIT = exports.POST_AUTH_INIT = 'POST_AUTH_INIT';
var POST_AUTH_COMPLETE = exports.POST_AUTH_COMPLETE = 'POST_AUTH_COMPLETE';
var POST_CREATE_APP_INIT = exports.POST_CREATE_APP_INIT = 'POST_CREATE_APP_INIT';
var POST_CREATE_APP_COMPLETE = exports.POST_CREATE_APP_COMPLETE = 'POST_CREATE_APP_COMPLETE';
var POST_CREATE_APPLICANT_INIT = exports.POST_CREATE_APPLICANT_INIT = 'POST_CREATE_APPLICANT_INIT';
var POST_CREATE_APPLICANT_COMPLETE = exports.POST_CREATE_APPLICANT_COMPLETE = 'POST_CREATE_APPLICANT_COMPLETE';
var POST_MAKE_PAYMENT_INIT = exports.POST_MAKE_PAYMENT_INIT = 'POST_MAKE_PAYMENT_INIT';
var POST_MAKE_PAYMENT_COMPLETE = exports.POST_MAKE_PAYMENT_COMPLETE = 'POST_MAKE_PAYMENT_COMPLETE';
var PUT_UPDATE_APP_INIT = exports.PUT_UPDATE_APP_INIT = 'PUT_UPDATE_APP_INIT';
var PUT_UPDATE_APP_COMPLETE = exports.PUT_UPDATE_APP_COMPLETE = 'PUT_UPDATE_APP_COMPLETE';
var PUT_UPDATE_APPLICANT_INIT = exports.PUT_UPDATE_APPLICANT_INIT = 'PUT_UPDATE_APPLICANT_INIT';
var PUT_UPDATE_APPLICANT_COMPLETE = exports.PUT_UPDATE_APPLICANT_COMPLETE = 'PUT_UPDATE_APPLICANT_COMPLETE';
var PATCH_UPDATE_APPLICANT_INIT = exports.PATCH_UPDATE_APPLICANT_INIT = 'PATCH_UPDATE_APPLICANT_INIT';
var PATCH_UPDATE_APPLICANT_COMPLETE = exports.PATCH_UPDATE_APPLICANT_COMPLETE = 'PATCH_UPDATE_APPLICANT_COMPLETE';
var APP_SUBMIT_FAILED = exports.APP_SUBMIT_FAILED = 'redux-form/SUBMIT_FAILED';
var GET_QUOTE_NUMBER = exports.GET_QUOTE_NUMBER = 'GET_QUOTE_NUMBER';
var SET_LOADING_TRUE = exports.SET_LOADING_TRUE = 'SET_LOADING_TRUE';
var SET_MAIL_STATUS = exports.SET_MAIL_STATUS = 'SET_MAIL_STATUS';
var EMAIL_SENT = exports.EMAIL_SENT = 'EMAIL_SENT';
var EMAIL_FAIL = exports.EMAIL_FAIL = 'EMAIL_FAIL';

var RESET_MSH_QUOTE = exports.RESET_MSH_QUOTE = 'RESET_MSH_QUOTE';
var GET_MSH_QUOTE_COMPLETE = exports.GET_MSH_QUOTE_COMPLETE = 'GET_MSH_QUOTE_COMPLETE';
var GET_ELIGIBILITY_ERROR = exports.GET_ELIGIBILITY_ERROR = 'GET_ELIGIBILITY_ERROR';
var GET_ELIGIBILITY_COMPLETE = exports.GET_ELIGIBILITY_COMPLETE = 'GET_ELIGIBILITY_COMPLETE';

var GET_QUESTIONNAIRE_DATA = exports.GET_QUESTIONNAIRE_DATA = 'GET_QUESTIONNAIRE_DATA';
var SUBMIT_QUESTIONNAIRE_DATA = exports.SUBMIT_QUESTIONNAIRE_DATA = 'SUBMIT_QUESTIONNAIRE_DATA';
var ERROR_QUESTIONNAIRE_DATA = exports.ERROR_QUESTIONNAIRE_DATA = 'ERROR_QUESTIONNAIRE_DATA';

var GET_FAILED_DETAILS_INIT = exports.GET_FAILED_DETAILS_INIT = 'GET_FAILED_DETAILS_INIT';
var GET_FAILED_DETAILS_COMPLETE = exports.GET_FAILED_DETAILS_COMPLETE = 'GET_FAILED_DETAILS_COMPLETE';

var PROCESS_FAILED_PAYMENTS_INIT = exports.PROCESS_FAILED_PAYMENTS_INIT = 'PROCESS_FAILED_PAYMENTS_INIT';
var PROCESS_FAILED_PAYMENTS_COMPLETE = exports.PROCESS_FAILED_PAYMENTS_COMPLETE = 'PROCESS_FAILED_PAYMENTS_COMPLETE';

var POST_CONTACT_FORM_INIT = exports.POST_CONTACT_FORM_INIT = 'POST_CONTACT_FORM_INIT';
var POST_CONTACT_FORM_COMPLETE = exports.POST_CONTACT_FORM_COMPLETE = 'POST_CONTACT_FORM_COMPLETE';
var RESET_CONTACT_FORM = exports.RESET_CONTACT_FORM = 'RESET_CONTACT_FORM';


//////////////////
// WEBPACK FOOTER
// ./src/v2/actions/Constants.js
// module id = 119
// module chunks = 0